import React, { FC, HTMLAttributes } from 'react';
import cn from 'classnames';

type CounterProps = {
  value: number | string;
  size?: 'sm' | 'md';
  position?: 'top-right' | 'top-left';
} & HTMLAttributes<HTMLDivElement>;

/**
 * Counter above pictures in dynamic bundle. Showing of how many items in the bundle.
 * Similar component is being used in checkout summary page.
 * TODO: use only 1 version of the component for all counter places
 */
export const Counter: FC<CounterProps> = ({
  value,
  size = 'sm',
  position = 'top-right',
  ...rest
}) => {
  const sizeClass = size === 'sm' ? 'h-5 w-5 text-xs mr-1' : 'h-7 w-7 text-base font-mindset';
  const positionClass = position === 'top-right' ? 'top-0 right-0' : 'top-0 left-0';

  return (
    <div
      {...rest}
      className={cn(
        'bg-primary-main text-text-dark-bg-contrast-white absolute flex items-center justify-center rounded-full text-center font-medium',
        sizeClass,
        positionClass
      )}
    >
      {value}
    </div>
  );
};
